import { ServiceClient } from 'src/utils'
import { NotificationRow, ShowNotificationRow, UpdateNotificationRow, UserNotification } from './scopes'

const serviceClient = ServiceClient.singleton()

export class NotificationManagerService {
    static #INSTANCE = new NotificationManagerService()
    static readonly singleton = () => NotificationManagerService.#INSTANCE

    async fetchMyNotifications(showRead: boolean, showExpired: boolean): Promise<UserNotification[]> {
        return serviceClient.authGet<UserNotification[]>(
            `/api/notification?showRead=${showRead}&showExpired=${showExpired}`
        )
    }

    async markAsRead(notificationId: number[]): Promise<NotificationRow> {
        return serviceClient.authPut<NotificationRow>(`/api/notification/markAsRead`, notificationId)
    }

    async fetchAll(filter: string): Promise<ShowNotificationRow[]> {
        return serviceClient.authGet<ShowNotificationRow[]>(
            `/api/notification/manager/all${filter ? '?filter=' + filter : ''}`
        )
    }

    async fetchById(id: number): Promise<NotificationRow> {
        return serviceClient.authGet<NotificationRow>(`/api/notification/manager/get/${id}`)
    }

    async create(notification: UpdateNotificationRow): Promise<NotificationRow> {
        return serviceClient.authPost<NotificationRow>('/api/notification/manager/new', notification)
    }

    async update(notificationId: number, notification: UpdateNotificationRow): Promise<NotificationRow> {
        return serviceClient.authPut<NotificationRow>(
            `/api/notification/manager/update/${notificationId}`,
            notification
        )
    }

    async delete(notificationId: number): Promise<void> {
        await serviceClient.authDelete(`/api/notification/manager/delete/${notificationId}`)
    }
}

export default NotificationManagerService.singleton()
